// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3aFzU","buttons":"RemoveExpirationActionButtons_buttons__3ku14"};